import { Icon } from "@iconify/react/dist/iconify.js";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";
import Paggination from "../Paggination";
import Loader from "../Loader/Loader";
import {
  copyToClipboard,
  formatDateInAMPM,
  stripHtml,
  trimAddress,
} from "../../utils/helper";
import AddProposalModal from "../model/AddProposalModal";
import SetQuorumModal from "../model/SetQuorumModal";
import SetTotalVotersCountModal from "../model/SetTotalVotersCountModal";
import { readContracts } from "@wagmi/core";
import { DAO_ABI } from "../../Contract/DAO_ABI";
import { DAO_CONTRACT_ADDRESS } from "../../utils/constant";
import { config } from "../../config";
import { formatUnits } from "viem";

const ProposalLayer = () => {
  const { AsyncGetApiCall } = useApi();
  const navigate = useNavigate();
  const [query, setQuery] = useState({
    pageNo: 1,
    limitVal: 50,
    search: "",
    status: "",
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalMode, setModalMode] = useState("create");
  const [showModal, setShowModal] = useState({
    create: false,
    execute: false,
    quorum: false,
    totalVoters: false,
  });

  const [globalData, setGlobalData] = useState({
    quorumPercentage: "",
    totalVotersCount: "",
    proposalCount: "",
    minVotingPower: "",
  });

  const [modalData, setModalData] = useState({});

  const fetchDaoValues = useCallback(async () => {
    try {
      setLoading(true);

      const results = await readContracts(config, {
        contracts: [
          {
            abi: DAO_ABI,
            address: DAO_CONTRACT_ADDRESS,
            functionName: "proposalCount",
          },
          {
            abi: DAO_ABI,
            address: DAO_CONTRACT_ADDRESS,
            functionName: "quorumPercentage",
          },
          {
            abi: DAO_ABI,
            address: DAO_CONTRACT_ADDRESS,
            functionName: "totalVotersCount",
          },
          {
            abi: DAO_ABI,
            address: DAO_CONTRACT_ADDRESS,
            functionName: "minVotingPower",
          },
        ],
      });

      console.log("results ---- : ", results);

      // const eachTokenPrice = formatUnits(results[0].result, 8);

      setGlobalData((prev) => ({
        ...prev,
        proposalCount: String(results[0]?.result),
        quorumPercentage: String(results[1]?.result),
        totalVotersCount: String(results[2]?.result),
        minVotingPower: String(formatUnits(results[3]?.result, 18)),
      }));
    } catch (error) {
      console.error("Something went wrong:", error);
    } finally {
      setLoading(false);
    }
  }, []); // Empty deps since it doesn't rely on external state

  useEffect(() => {
    fetchDaoValues();
  }, []);

  const setPageNo = (pageNo) => {
    setQuery((prev) => ({
      ...prev,
      pageNo: pageNo,
    }));
  };

  const handleModalClose = (shouldRefresh = false) => {
    setShowModal({ create: false, quorum: false, totalVoters: false });
    setModalData(null);
    if (shouldRefresh) getAllProposalList();
  };

  const getAllProposalList = async (showLoader = true) => {
    try {
      if (showLoader) {
        setLoading(true);
      }
      console.log("query...", query);
      const result = await AsyncGetApiCall("/proposal/list", query);
      console.log("Resuls of propsal list:", result);

      if (result?.success) {
        setData(result || []);
      } else {
        toast.error(result?.message || "Failed to fetch proposal data");
      }
    } catch (error) {
      console.log("error...", error);
      toast.error("An error occurred while fetching proposal data");
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getAllProposalList(true);
  }, [query]);

  console.log("data", data);

  return (
    <>
      {loading && <Loader />}
      {/* Proposal Stats Cards */}
      <div className="row row-cols-xxxl-4 row-cols-lg-4 row-cols-sm-2 row-cols-1 gy-4 mb-4">
        {/* Quorum */}
        <div className="col">
          <div className="card shadow-none border bg-gradient-start-1 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">Quorum</p>
                  <h6 className="mb-0">{globalData?.quorumPercentage}</h6>
                </div>
                <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="mdi:percent-outline"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Total Voters */}
        <div className="col">
          <div className="card shadow-none border bg-gradient-start-2 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    Total Voters
                  </p>
                  <h6 className="mb-0">
                    {globalData?.totalVotersCount
                      ? Number(formatUnits(globalData?.totalVotersCount, 18))
                      : 0}
                  </h6>
                </div>
                <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="mdi:account-group-outline"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Total Proposals */}
        <div className="col">
          <div className="card shadow-none border bg-gradient-start-3 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    Total Proposals
                  </p>
                  <h6 className="mb-0">{globalData?.proposalCount || 0}</h6>
                </div>
                <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="mdi:file-document-outline"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Min Voting Power */}
        <div className="col">
          <div className="card shadow-none border bg-gradient-start-4 h-100">
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    Min Voting Power
                  </p>
                  <h6 className="mb-0">{globalData?.minVotingPower || "-"}</h6>
                </div>
                <div className="w-50-px h-50-px bg-success-main rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="mdi:shield-account-outline"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card h-100 p-0 radius-12 my-3">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 w-100">
            <div className="d-flex align-items-center flex-wrap gap-3">
              <span className="text-md fw-medium text-secondary-light mb-0">
                Show
              </span>
              <select
                className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                value={query?.limitVal}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10);
                  setQuery((prev) => ({
                    ...prev,
                    limitVal: value,
                    pageNo: 1,
                  }));
                }}
              >
                {Array.from({ length: 20 }, (_, i) => {
                  const value = (i + 1) * 5;
                  return (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="d-flex align-items-center gap-3">
              <button
                type="button"
                className="btn btn-success radius-8 px-17 py-9 d-flex align-items-center gap-2"
                onClick={() => {
                  setModalData(null);
                  setShowModal({ ...showModal, totalVoters: true });
                }}
                disabled={loading}
              >
                <Icon
                  icon="ic:outline-how-to-vote"
                  className="menu-icon"
                  width="24"
                  height="24"
                />
                Set Total Voters Count
              </button>

              <button
                type="button"
                className="btn btn-secondary radius-8 px-17 py-9 d-flex align-items-center gap-2"
                onClick={() => {
                  setModalData(null);
                  setShowModal({ ...showModal, quorum: true });
                }}
                disabled={loading}
              >
                <Icon
                  icon="ic:outline-people"
                  className="menu-icon"
                  width="24"
                  height="24"
                />
                Set Quorum
              </button>

              <button
                type="button"
                className="btn btn-primary-600 radius-8 px-17 py-9 d-flex align-items-center gap-2"
                onClick={() => {
                  setModalMode("create");
                  setModalData(null);
                  setShowModal({ ...showModal, create: true });
                }}
                disabled={loading}
              >
                <Icon
                  icon="ic:outline-note-add"
                  className="menu-icon"
                  width="24"
                  height="24"
                />
                Create Proposal
              </button>
            </div>
          </div>
        </div>

        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="d-flex align-items-center gap-10">
                      <div className="form-check style-check d-flex align-items-center"></div>
                      Proposal Id
                    </div>
                  </th>
                  <th scope="col">Title</th>
                  <th scope="col">Description</th>
                  <th scope="col">Start Time</th>
                  <th scope="col">End Time</th>
                  <th scope="col">Status</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.data && data?.data?.length > 0 ? (
                  data?.data?.map((proposal, index) => (
                    <tr key={proposal._id}>
                      <td>
                        <div className="d-flex justify-content-center align-items-center gap-10">
                          {proposal?.proposalId || "N/A"}
                        </div>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {trimAddress(stripHtml(proposal?.title || ""), 6, 6)}
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {trimAddress(
                            stripHtml(proposal?.description || ""),
                            6,
                            6
                          )}
                          <button
                            onClick={() =>
                              copyToClipboard(proposal?.description)
                            }
                            className="ms-3 p-0 border-0 bg-transparent"
                            style={{ lineHeight: 1 }}
                          ></button>
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {proposal?.startTime
                            ? formatDateInAMPM(proposal?.startTime * 1000)
                            : "N/A"}
                        </span>
                      </td>

                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {proposal?.endTime
                            ? formatDateInAMPM(proposal?.endTime * 1000)
                            : "N/A"}
                        </span>
                      </td>

                      <td>
                        <span
                          className={`badge ${
                            proposal?.executed === true
                              ? "bg-success-100 text-success-600"
                              : proposal?.cancelled === true
                              ? "bg-danger-100 text-danger-600"
                              : "bg-warning-100 text-warning-600"
                          } text-sm py-4 px-10 radius-4`}
                        >
                          {proposal?.executed === true
                            ? "Executed"
                            : proposal?.cancelled === true
                            ? "Cancelled"
                            : "Pending"}
                        </span>
                      </td>

                      <td>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            type="button"
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() =>
                              navigate(
                                `/proposal-view/${proposal?.proposalId || 1}`,
                                { state: { propId: proposal?._id } }
                              )
                            }
                          >
                            <Icon
                              icon="majesticons:eye-line"
                              className="icon text-xl"
                            />
                            <span className="tooltip-text">View</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No proposal found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paggination
            total={data?.total || 0}
            totalPages={data?.totalPages || 0}
            currentPage={data?.currentPage || 0}
            setPageNo={setPageNo}
            startFrom={(data?.currentPage - 1) * query.limitVal + 1}
            endTo={
              (data?.currentPage - 1) * query.limitVal +
              (data?.data?.length || 0)
            }
          />

          {showModal.create && (
            <AddProposalModal
              show={showModal.create}
              handleClose={handleModalClose}
              mode={modalMode}
              data={modalData}
            />
          )}

          {showModal.quorum && (
            <SetQuorumModal
              show={showModal.quorum}
              handleClose={handleModalClose}
              initialQuorum={globalData?.quorumPercentage}
            />
          )}

          {showModal.totalVoters && (
            <SetTotalVotersCountModal
              show={showModal.totalVoters}
              handleClose={handleModalClose}
              initialTotalVoters={globalData?.totalVotersCount}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ProposalLayer;
